<template>
  <div>
    <div class="emerbox" v-loading="loading">
      <div class="panel-l">
        <div class="item" :class="{activeSel:selectIndex===index}" @click="change(item,index)" v-for="(item,index) in supplyList" :key="index">
          {{item.name}}
          <el-button type="primary" size="small" style="margin-left:10px;">{{countResArr[index] || 0}}</el-button>
        </div>
        <el-button type="primary" size="large" @click="add" style="position: relative;left: 50%;transform: translate(-50%);">添加</el-button>
        <!-- <p class="p_t">找不到物资？<span style="color: #20a0ff;cursor: pointer" @click="addnew = true">我要新增</span></p> -->
      </div>
      <div class="panel-r">
        <div v-for="(item,i) in supplyModel" :key="i" v-show="'model' + selectIndex == i" class="panel-d">
          <div v-for="(m,k) in item" :key="k" class="panel-d-t">
            <p>
              <span>{{m.name}}</span>
              <el-input-number v-model="m['count']" :min="0" :max="9999" size="small" @change="changeNumber"></el-input-number>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!--添加应急物资-->
    <el-dialog title="添加应急物资" v-model="dialogVisible" size="small" id="dialogVisible">
      <div style="overflow: hidden;">
        <div class="risk-left">
          <div class="top">
            <el-input placeholder="搜索" icon="search" @keyup.enter.native="get_material_list" size="small" v-model="searchrisk" :on-icon-click="handleIconClick">
            </el-input>
          </div>
          <div class="list">
            <ul>
              <li v-for="(item,index) in materialData.content" :key="index" :class="{activeS:matSelIndex===index}" @click="handleSel(item,index)">
                {{item.name}}
              </li>
            </ul>
          </div>
        </div>
        <div class="risk-right">
          <div class="it">
            <span class="tlt">物资：</span>
            <span class="value" :title="paramsModel.name">{{paramsModel.name}}</span>
          </div>
          <div class="it">
            <span class="tlt">分类：</span>
            <span class="value">{{paramsModel.cas}}</span>
          </div>
          <div class="it">
            <span class="tlt">数量：</span>
            <span class="value">
							<el-input-number v-model="paramsModel.count" :min="1" :step="1" size="small"></el-input-number>
						</span>
          </div>
        </div>
      </div>
<!--      <p class="p_t">找不到物资？<span style="color: #20a0ff;cursor: pointer" @click="addnew = true">我要新增</span></p>-->
      <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="submitMt">确 定</el-button>
	  </span>
    </el-dialog>
    <!-- 添加风险物质 -->
    <el-dialog title="新增物资" :visible.sync="addnew" size="tiny">
      <el-form ref="formlist" :model="formlist" label-width="50px">
        <el-form-item label="物资">
          <el-input v-model="formlist.name"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="formlist.parent" placeholder="请选择" style="width:100%">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="addnew = false">取 消</el-button>
    <el-button type="primary" @click="addnewsupply">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>
<script>
import Burst from './../../data/emer/burst'
import supply from '../../data/emer/supply.js'
export default {
  data() {
    return {
      loading: false,
      dialogVisible:false,
      searchrisk: '',
      materialData: [],
      matSelIndex: -1,
      paramsModel: {
        count: 0,
        materialId: '',
        name: '',
        cas: '',
      },
      supplyList: [],
      selectIndex: 0,
      charildArr: [],
      num1: '',
      supplyModel: {
        model0: {},
        model1: {},
        model2: {},
        model3: {},
      },
      params: {},
      countRes: {},
      countResArr: [],
      isSave: false,
      addnew: false,
      // 新增风险
      formlist: {
        name: '',
        parent: '14000',
        parentName: '',
        remark: '',
        verifiedStatus: ''
      },
      options: [{
        value: '11000',
        label: '应急监测仪器',
        model: 0,
      }, {
        value: '12000',
        label: '个人防护类物资',
        model: 1,
      }, {
        value: '13000',
        label: '污染控制类物资',
        model: 2,
      }, {
        value: '14000',
        label: '其他物资',
        model: 3,
      }],
      value2: '',
      pageTime:1,
    }
  },
  created() {
    let _this = this;
    _this.get_list()
  },

  methods: {
    changeNumber () {
      this.get_format_res()
      if (!this.params.emergencyMaterial.length) return
      this.save_supplymaterila()
    },
    addnewsupply() {
      this.add_supply()
    },
    change(item, index) {
      this.selectIndex = index
    },
    // 新增应急物资
    add_supply() {
      (async() => {
        let createState = await supply.create(this.formlist)
        if (createState.status) {
          this.$message.success('应急物资新增成功');
          setTimeout(() => {
            this.addnew = false
            this.get_supply_tree()
            this.searchrisk = this.formlist.name
            this.handleIconClick()
          }, 100)
        } else {
          this.$message.error(createState.msg);
        }
      })()
    },
    get_list() {
      (async() => {
        try {
          let info = await Burst.get_material_list({
            planId: sessionStorage.planIdval,
          })
          if (info.status) {
            this.params = {
              planId: sessionStorage.planIdval,
              emergencyMaterial: info.data
            }
            this.get_format_supplyModel(info.data);
          }

          this.loading = false;
        } catch (err) {
          this.loading = false;
          console.log(err)
        }
      })()
    },
    //格式化选中的物质
    get_format_supplyModel (data) {
      let self = this;
      let ids = data.map(item => {return item.materialId});
      ids = ids.join(',');
      (async() => {
        try {
          let info = await supply.search({
            ids: ids,
            size: 1000000
          });
          this.supplyModel = {
            model0: {},
            model1: {},
            model2: {},
            model3: {},
          }
          let parentInfoData = info.content;
          for(let i = 0; i< parentInfoData.length; i++) {
            let nowData = data.filter((item) => {
              return item.materialId == parentInfoData[i].id;
            })[0]
            let model = self.options.filter((item) => {
              return item.value == parentInfoData[i].parent;
            })[0].model;
            this.supplyModel['model' + model][i] = {};
            this.supplyModel['model' + model][i]['name'] = nowData.name;
            this.supplyModel['model' + model][i]['count'] = nowData.count;
            this.supplyModel['model' + model][i]['materialId'] = nowData.materialId;
          }
          this.get_format_res()
        } catch (err) {
          this.loading = false;
          console.log(err)
        }
      })()
    },
    // 获取格式化后的 信息
    get_format_res() {
      let newArr = [] // 存储一级 model
      let arr = [] // 存储所有model的子元素
      let res = [] // 过滤所有大于0的元素
      let newInfo = []
      let countRes = Object.assign({}, this.countRes)

      this.supplyList.map((item, i) => {
        newArr.push(this.supplyModel['model' + i])
      })

      for (let i = 0; i < newArr.length; i++) {
        for (let k in newArr[i]) {
          arr.push(newArr[i][k])
          countRes['count' + i] = parseInt(countRes['count' + i]) + parseInt(newArr[i][k].count)
        }
      }
      // 过滤
      arr.map(item => {
        if (item.count >= 1) res.push(item)
      })
      for (let m in countRes) {
        newInfo.push(countRes[m])
      }
      this.countResArr = newInfo

      this.params = {
        planId: sessionStorage.planIdval,
        emergencyMaterial: res
      }
    },
    // 验证`
    verifyResult() {
      if (!this.params.emergencyMaterial.length) {
        return {
          status: false,
          msg: '应急物资信息不完善，请填写'
        }
      }
      return {
        status: true,
        msg: 'ok'
      }
    },
    // 保存
    save_supplymaterila() {
      (async() => {
        try {
          let info = await Burst.supplymaterila_save(this.params)
          this.get_list();
          if (!info.status){
            this.$message.error(info.msg)
          }
        } catch (err) {
          this.$message.error('网络错误，请稍后重试')
        }
      })()
    },
    rest() {
      this.params = {}
      this.supplyModel = {}
      this.loading = true;
      this.get_supply_tree()
    },

    // 获取树形目录
    get_supply_tree() {
      return new Promise((resolve, reject) => {
        (async() => {
          try {
            let info = await Burst.supply_tree()
            this.supplyList = info.data[0].children
            let countModel = {}
            this.supplyList.map((item, i) => {
              countModel['count' + i] = 0
            })

            this.countRes = countModel
            this.get_list()
            resolve(1);
          } catch (err) {
            this.loading = false;
            this.$message.error('网络错误，请稍后重试')
            reject(err);
          }
        })()
      })

    },
    // 以下为应急物质页面增加的方法
    add(){
      this.dialogVisible = true;
      this.get_material_list()
    },
    // 获取通过模糊搜索返回的物资
    get_material_list(){
        (async() => {
          let info = await supply.search({
            keyword:this.searchrisk,
            size:1000
          })
          for (let i = 0; i < info.content.length; i++) {
              if (info.content[i].parent == -1) {
                info.content.splice(i, 1)
              }
          }
          this.materialData = info
        })()
    },
    // 点击搜索按钮的出发的方法
    handleIconClick() {
      this.get_material_list()
    },
    // 点击具体物质时触发的方法
    handleSel(item, index) {
      let count ;
      for (const i in this.supplyModel) {
        for (const j in this.supplyModel[i]) {
            if (this.supplyModel[i][j].materialId == item.id) {
              count = this.supplyModel[i][j].count
            }
        }
      }
      this.matSelIndex = index
      this.paramsModel = {
        count: count,
        materialId: item.id,
        name: item.name,
        cas: item.parentName,
      }
    },
    // 提交
    submitMt(){
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].label == this.paramsModel.cas) {
          this.change(null, i)
        }
      }
      this.add_supplyModel()
    },
    add_supplyModel () {
      let self = this;
      let model = self.options.filter((item) => {
        return item.label == self.paramsModel.cas;
      })[0].model;
      let length = this.supplyModel['model' + model].length;
      for(let i = 0; i< length; i++) {
        if(this.supplyModel['model' + model][i].materialId == self.paramsModel.materialId) {
          this.supplyModel['model' + model][i].count = self.paramsModel.count;
          return false;
        }
      }
      this.supplyModel['model' + model][length] = {};
      this.supplyModel['model' + model][length]['name'] = self.paramsModel.name;
      this.supplyModel['model' + model][length]['count'] = self.paramsModel.count;
      this.supplyModel['model' + model][length]['materialId'] = self.paramsModel.materialId;
      this.paramsModel = {}
      this.changeNumber();
      this.dialogVisible = false
    }
  }
}

</script>
<style scoped lang="stylus">
.el-dialog__wrapper>>>.el-dialog--small{
  width 822px
}
.risk-left {
  width: 200px;
  height: 360px;
  border: 1px solid #ccc;
  overflow: hidden;
  float: left;
}
.top {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  position: relative;
}
.list {
  width: 100%;
  height: 310px;
  overflow-y: auto;
  border-top: 1px solid #ccc;
}

.list li {
  line-height: 30px;
  padding: 0 10px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: all 0.5s ease-in;
}

.list li:nth-child(2n) {
  background: #f9f9f9
}

.list li:hover,
.list li.activeS {
  color: #00c0ef;
  background-color: #ecf5ff;
}

.it {
  padding-left: 20px;
  line-height: 40px;
  height: 40px;
  overflow: hidden;
  border-bottom: 1px dashed #ccc;
}

.value {
  display: inline-block;
  width: 336px;
  height: 40px;
  float: left;
}

.it .tlt {
  width: 85px;
  display: inline-block;
  float: left;
  text-align: right;
  margin-right: 20px;
}

.emerbox {
  width: 100%;
  height: auto;
  min-height: 300px;
  border: 1px solid #ccc;
  display: flex;
}

.item {
  overflow: hidden;
  transition: all 0.5s ease-in;
  width: 200px;
  line-height: 60px;
  cursor: pointer;
  text-indent: 10px;
}

.panel-l {
  margin-top: 15px;
  margin-bottom: 15px; // flex: 2;
  width: 200px;
  border-right: 1px solid #ccc;
  font-size: 14px;
  .item {
    button {
      padding: 3px 5px;
      float: right;
      margin-right: 10px;
      margin-top: 19px;
    }
  }
}

.panel-r {
  overflow: auto;
  max-height: 500px;
  box-sizing: border-box;
  .panel-d {
    .panel-d-t {
      box-sizing: border-box;
      width: 330px;
      height: 60px;
      margin: 15px 25px;
      line-height: 60px;
      background: rgb(245, 245, 247);
      padding: 0 20px;
      float: left;
      p {
        span {
          width: 150px;
          font-size: 12px;
          float: left
        }
        div {
          display: inline-block;
          position: relative;
          top: 15px;
          float: right;
        }
      }
    }
  }
}

.item:hover,
.item.activeSel {
  color: #20a0ff;
}

.circle {
  padding: 0px 3px;
  border-radius: 100%;
  background: #00c0ef;
  color: #fff;
  margin-left: 10px;
  font-size: 12px;
}

.p_t {
  margin: 30px 0 0 10px;
}

</style>



// WEBPACK FOOTER //
// emergency.vue?0149f51b